<template>
  <div data-app class="w-100 my-5">
    <div class="box-white d-flex flex-column">
      <div class="row w-100 mt-5 vertical-center">
        <span class="col-sm-2 m-1 font-bold font-12 alpha-07">{{ $t('coupon_code') }}</span>
        <input class="col-sm m-1 font-12" v-model="couponCode" />
      </div>
      <div class="row w-100 mt-5 vertical-center">
        <span class="col-sm-2 m-1 font-bold font-12 alpha-07">{{ $t('percent') }}</span>
        <input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="col-sm m-1 font-12" v-model="percent" />
      </div>
      <div class="row w-100 mt-5 vertical-center">
        <span class="col-sm-2 m-1 font-bold font-12 alpha-07">{{ $t('total_quantity') }}</span>
        <input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="col-sm m-1 font-12" v-model="totalQuantity" />
      </div>
      <div class="row w-100 mt-5 vertical-center">
        <span class="col-sm-2 m-1 font-bold font-12 alpha-07">{{ $t('influencer') }}</span>
        <input class="col-sm m-1 font-12" v-model="selectedInfluencers" disabled />
      </div>
      <div class="mt-1 d-flex justify-content-end">
        <v-btn class="mx-5 button-normal" small @click="visibleInfluencerDialog = true" :disabled="userList.length === 0">
          <span>{{ $t('select_influencer') }}</span>
        </v-btn>
        <v-btn class="mx-5 button-normal" small @click="selectedInfluencerList = []; selectedInfluencers = ''" :disabled="selectedInfluencerList.length <= 0">
          <span>{{ $t('clear') }}</span>
        </v-btn>
      </div>
      <div class="my-5 d-flex justify-content-end">
        <v-btn class="mx-5 button-normal" small @click="setCouponCode()" :disabled="(!couponCode || percent <= 0 || totalQuantity <= 0)">
          <span>{{ $t('confirm') }}</span>
        </v-btn>
        <v-btn class="mx-5 button-normal" small @click="resetInput()" :disabled="(!couponCode && percent <= 0 && totalQuantity <= 0 && selectedInfluencerList.length <= 0)">
          <span>{{ $t('cancel') }}</span>
        </v-btn>
      </div>
    </div>
    <div class="row my-5" v-if="(items.length > 0)">
      <div :class="`col-sm${colSmSize}`" v-for="(item, index) in items" :key="(item, index)">
        <div class="my-2 box-white d-flex flex-column">
          <span class="mt-2 ellipsis font-bold font-16">{{ `${$t('coupon_code')} : ${item.couponCode}` }}</span>
          <div class="my-2 vertical-center">
            <span class="ellipsis font-15 font-bold color-red">{{ `${$t('percent')} : ${item.percent}%` }}</span>
          </div>
          <div class="my-2 vertical-center">
            <span class="font-15 color-blue">{{ `${$t('total_quantity')} : ${item.totalQuantity}` }},</span>
            <span class="ml-2 font-15 color-blue">{{ `${$t('used_quantity')} : ${item.usedQuantity}` }}</span>
          </div>
          <span class="mt-2 ellipsis font-bold font-16">{{ `${$t('influencer')} : ${getInfluencers(item.influencerList)}` }}</span>
          <div class="m-2 d-flex justify-content-end vertical-center">
            <v-btn class="ml-5 button-normal" small @click="handleEdit(item)">
              <span>{{ $t('edit') }}</span>
            </v-btn>
            <v-btn class="ml-5 button-normal" small @click="handleDelete(item)">
              <span>{{ $t('delete') }}</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <!-- Start Select Influencer Dialog -->
    <v-dialog v-model="visibleInfluencerDialog" scrollable width="800px">
      <v-card>
        <v-card-title class="d-flex flex-column">
          <div class="w-100 d-flex justify-content-between">
            <span class="font-bold font-18">{{ $t('select_influencer') }}</span>
            <v-btn class="ml-auto" icon small @click="visibleInfluencerDialog = false; keyword = '';">
              <i class="flaticon-cancel font-bold font-25 color-black"></i>
            </v-btn>
          </div>
          <div class="w-100 my-1 vertical-center">
            <input class="w-100" v-model="keyword" />
            <v-btn class="ml-2" icon small @click="keyword = ''" :disabled="!keyword">
              <i :class="`flaticon-circle ${keyword.length > 0 ? 'color-blue' : ''}`"></i>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="m-2 box-white pointer vertical-center d-flex" v-for="(item, index) in influencerList" :key="index" @click="onInfluencerSelected(item)">
            <img class="circle-image-30 m-1" :src="item.photoUrl || assets.profile" />
            <span :class="`ml-5 font-bold ${isMobile ? 'font-12' : 'font-15'}`"> {{ item.userName }}</span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End Select Influencer Dialog -->
  </div>
</template>

<script>
import { isAlphanumeric, showLoading } from '../../../functions';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../main';

import profile from '@/assets/image/profile.jpg';

export default {
  name: 'EditCoupon',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    colSmSize() {
      return this.$store.state.colSmSize;
    },
    couponList() {
      return this.$store.state.couponList;
    },
    userList() {
      if (this.$store.state.userList) {
        return this.$store.state.userList.filter(element => element.userType === 2);
      } else {
        return [];
      }
    }
  },
  watch: {
    couponList() {
      this.refreshData();
    },
    userList(newList, oldList) {
      const oldCount = oldList ? oldList.length : 0;
      const newCount = newList ? newList.length : 0;
      if (oldCount !== newCount) {
        this.refreshInfluencerList();
      }
    },
    keyword() {
      this.refreshInfluencerList();
    }
  },
  data() {
    return {
      assets: {
        profile
      },
      couponCode: '',
      percent: 0,
      totalQuantity: 0,
      influencerList: [],
      selectedInfluencerList: [],
      selectedInfluencers: '',
      visibleInfluencerDialog: false,
      keyword: '',
      items: [],
      editingItem: null,
    }
  },
  mounted() {
    this.refreshData();
    this.refreshInfluencerList();
  },
  methods: {
    refreshData() {
      if (this.couponList) {
        this.items = this.couponList.filter(element => element.eventId === this.$route.params.eventId);
      }
    },
    refreshInfluencerList() {
      const keyword = this.keyword.toLowerCase();
      this.influencerList = this.userList.filter(element => element.userName.toLowerCase().includes(keyword));
    },
    setCouponCode() {
      if (!this.couponCode) {
        this.$toast.info('Please enter code');
        return;
      }
      if (!isAlphanumeric(this.couponCode)) {
        this.$toast.info('Please enter only alpha numeric code');
        return;
      }
      if (this.percent <= 0 || this.percent >= 100) {
        this.$toast.info('Please enter valid percent');
        return;
      }
      if (this.totalQuantity <= 0) {
        this.$toast.info('Please enter valid total quantity');
        return;
      }
      const influencerList = [];
      this.selectedInfluencerList.forEach(info => {
        influencerList.push(info.influencerId);
      });
      const params = {
        functionName: 'setCouponInfo',
        eventId: this.$route.params.eventId,
        couponCode: this.couponCode,
        percent: this.percent,
        totalQuantity: this.totalQuantity,
        influencerList: influencerList,
        couponId: '',
      };
      if (this.editingItem) {
        params['couponId'] = this.editingItem.couponId;
      }
      if (this.items.length) {
        const index = this.items.findIndex(ele => ele.couponCode === this.couponCode);
        if (index !== -1) {
          if ((this.editingItem && this.editingItem.couponCode !== this.couponCode) || !this.editingItem) {
            this.$toast.info('Coupon code can\'t be same.');
            return
          }
        }
      }
      this.handleTask(params);
    },
    getInfluencers(influencerList) {
      var influencers = '';
      if (influencerList) {
        influencerList.forEach(id => {
          const index = this.userList.findIndex(element => element.userId === id);
          if (index >= 0 && index < this.userList.length) {
            const influencerInfo = this.userList[index];
            if (influencers) {
              influencers += ', ';
            }
            influencers += influencerInfo.userName;
          }
        });
      }
      return influencers;
    },
    onInfluencerSelected(influencerInfo) {
      this.visibleInfluencerDialog = false;
      this.keyword = '';
      if (this.selectedInfluencers) {
        this.selectedInfluencers += ', ';
      }
      this.selectedInfluencers += influencerInfo.userName;
      this.selectedInfluencerList.push({
        influencerId: influencerInfo.userId,
        influencerName: influencerInfo.userName,
        photoUrl: influencerInfo.thumbnailUrl || influencerInfo.photoUrl
      });
    },
    resetInput() {
      this.couponCode = '';
      this.percent = 0;
      this.totalQuantity = 0;
      this.selectedInfluencerList = [];
      this.selectedInfluencers = '';
      this.editingItem = null;
    },
    handleEdit(couponInfo) {
      this.couponCode = couponInfo.couponCode;
      this.totalQuantity = couponInfo.totalQuantity;
      this.percent = couponInfo.percent;
      this.editingItem = couponInfo;
      this.selectedInfluencerList = [];
      this.selectedInfluencers = '';
      if (couponInfo.influencerList) {
        couponInfo.influencerList.forEach(id => {
          const index = this.userList.findIndex(element => element.userId === id);
          if (index >= 0 && index < this.userList.length) {
            const influencerInfo = this.userList[index];
            if (this.selectedInfluencers) {
              this.selectedInfluencers += ', ';
            }
            this.selectedInfluencers += influencerInfo.userName;
            this.selectedInfluencerList.push({
              influencerId: influencerInfo.userId,
              influencerName: influencerInfo.userName,
              photoUrl: influencerInfo.thumbnailUrl || influencerInfo.photoUrl
            });
          }
        });
      }
    },
    handleDelete(couponInfo) {
      const params = {
        couponId: couponInfo.couponId,
        functionName: 'setCouponInfo',
        isDelete: true
      }
      this.handleTask(params);
    },
    handleTask(params) {
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
          this.resetInput();
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>
